import React, { useEffect } from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { styled, globalCss } from '@uhg-abyss/web/tools/styled';
import { useUser } from '@src/state/user';
import { FeedbackTab } from '@src/common/FeedbackTab';
import { registerAnalytics } from '@src/common/tools/analytics';
import { V2FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { useFormV2 } from '@uhg-abyss/web/hooks/useForm';
import { Header } from './Header';
import { Footer } from './Footer';
import { Landing } from './Content/Landing';
import { VerifyTin } from './Content/VerifyTin';
import { SuperUser } from './Content/SuperUser';
import { UpdateSubmission } from './Content/UpdateSubmission';

globalCss({
  '.abyss-alert-root': {
    justifyContent: 'initial !important',
  },
  '.abyss-alert-wrapper': {
    maxWidth: 'initial !important',
  },
})();

const MainContainer = styled('div', {
  background: '$gray2',
  paddingBottom: 30,
  flex: '1 0 auto',
  minHeight: '136vh',
});

const Body = styled('div', {
  display: 'flex',
  minHeight: '100vh',
  fontFamily: '$primary',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

export const App = () => {
  const form = useFormV2({ mode: 'all' });
  const { getUserInfo } = useUser.actions();
  const { uuid } = useUser.state();

  useEffect(() => {
    registerAnalytics();
    getUserInfo();
  }, []);

  const pageTitle = '{{title}} | Out of Network Portal';

  return !uuid ? null : (
    <Body>
      <V2FormProvider state={form}>
        <Header />
        <MainContainer>
          <Router.Routes title={pageTitle}>
            <Router.Route path="/" element={<Landing title="dashboard" />} />
            <Router.Route
              path="/verify-tin"
              element={<VerifyTin title="Verify TIN" />}
            />
            <Router.Route
              path="/superuser"
              element={<SuperUser title="Super User" />}
            />
            <Router.Route
              path="/update-submission"
              element={<UpdateSubmission title="Update Submission" />}
            />
          </Router.Routes>
          <FeedbackTab />
        </MainContainer>
        <Footer />
      </V2FormProvider>
    </Body>
  );
};
